import React, { useEffect, useState } from 'react'
import Http from '../../../../Http'

export default function ManifiestoInfo({ manifiestoId = null }) {

  const [Manifiesto, setManifiesto] = useState({});

  useEffect(() => {
    const getMan = async () => {
      if (!manifiestoId) return;
      let Res = await Http.get(`cliente-manifiesto/one/${manifiestoId}`);
      console.log(Res);
      if (!Res.error)
        setManifiesto(Res.data);
    }

    getMan();
  }, [manifiestoId])

  return (
    <div>
      <p><b>Factura:</b> {Manifiesto.factura}</p>
      <p><b>Fecha embarque:</b> {Manifiesto.fecha_orden}</p>
      <p><b>Valor factura:</b> {Manifiesto.importe_factura}</p>
      <p><b>Cliente:</b> {Manifiesto.cliente_rsocial}</p>
      <p><b>Municipio:</b> {Manifiesto.sucursal_nombre}</p>
      <p><b>Cajas:</b> {Manifiesto.unidades}</p>
      {/* <p><b>Guia EXXP SLP:</b> {Manifiesto.factura}</p> */}
      <p><b>Fecha documentación:</b> {Manifiesto.g_fecha}</p>
      <p><b>Guia:</b> {Manifiesto.g_folio}</p>
    </div>
  )
}
